import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { notify, NotificationType } from 'xstate/actors/NotificationActor';
import { leaveBox } from 'networking/mindfeed/services/box.service';
import type { BoxId } from 'models/Box';

type Variables = {
  boxId: BoxId;
};

const useLeaveBox = () => {
  const queryClient = useQueryClient();

  const onSuccessCallback = async () => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.BOXES] });
    notify(NotificationType.BOX_MEMBER_LEFT);
  };

  return useMutation<void, Error, Variables>({
    mutationFn: (variables) => leaveBox(variables.boxId),
    onSuccess: onSuccessCallback,
  });
};

export default useLeaveBox;
